export default "__VITE_ASSET__CpXejkKn__"